import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import moment from "moment";
import {
  Button,
  FormControl,
  Pagination,
  Switch,
  TextField,
  Chip,
} from "@mui/material";
import { FaFilePdf } from "react-icons/fa";
import { getCookie } from "../../../../function";
import { jwtDecode } from "jwt-decode";
import { useState } from "react";
import ViewImage from "../../adminComponents/ViewImage";
import PaymentVerify from "../../adminComponents/PaymentVerify";
import getArticleService from "../../../../services/getArticleService";
import DeleteConfirm from "../../adminComponents/DeleteConfirm";
import { Badge } from "react-bootstrap";
import { getPublicationColor } from "../../../../config/publicationColors";
import { useNavigate } from "react-router-dom";
import ViewPdf from "../../clientArticle/viewPdf";
import ViewPaymentProof from "../../clientArticle/viewPaymentProof";
import { getPaymentStatus } from "../../../../utils/paymentStatus";
import { useAuth } from "../../../../context/AuthContext";

const uploadsUrl = process.env.REACT_APP_API_URL;

const columns = [
  { id: "id", label: "Article Id", minWidth: 120, align: "center" },

  { id: "name", label: "User Name", minWidth: 150, align: "center" },
  { id: "date", label: "Created At", minWidth: 150, align: "center" },
  { id: "date", label: "Last Modified", minWidth: 150, align: "center" },

  { id: "Journal Name", label: "Journal Name", minWidth: 200, align: "center" },
  {
    id: "Publication Name",
    label: "Publication Name",
    minWidth: 150,
    align: "center",
  },

  { id: "Payer Name", label: "Payer Name", minWidth: 150, align: "center" },
  {
    id: "Payer EmailId",
    label: "Payer Emailid",
    minWidth: 150,
    align: "center",
  },
  {
    id: "Currency",
    label: "Currency",
    minWidth: 100,
    align: "center",
  },
  { id: "Total Fees", label: "Total Fees", minWidth: 150, align: "center" },

  { id: "Tax Rate", label: "Tax Rate", minWidth: 150, align: "center" },
  { id: "Tax Amount", label: "Tax Amount", minWidth: 150, align: "center" },
  {
    id: "Fees Received",
    label: "Fees Received",
    minWidth: 150,
    align: "center",
  },
  {
    id: "Remaining Fees",
    label: "Remaining Fees",
    minWidth: 150,
    align: "center",
  },

  {
    id: "Payment Status",
    label: "Payment Status",
    minWidth: 320,
    format: (value) => value.toFixed(2),
    align: "center",
  },

  {
    id: "Action",
    label: "Action",
    minWidth: 250,
    format: (value) => value.toFixed(2),
    align: "center",
  },
];

function createData(name, code, population, size) {
  const density = population / size;
  return { name, code, population, size, density };
}

const rows = [
  createData("India", "IN", 1324171354, 3287263),
  createData("China", "CN", 1403500365, 9596961),
  createData("Italy", "IT", 60483973, 301340),
  createData("United States", "US", 327167434, 9833520),
  createData("Canada", "CA", 37602103, 9984670),
  createData("Australia", "AU", 25475400, 7692024),
  createData("Germany", "DE", 83019200, 357578),
  createData("Ireland", "IE", 4857000, 70273),
  createData("Mexico", "MX", 126577691, 1972550),
  createData("Japan", "JP", 126317000, 377973),
  createData("France", "FR", 67022000, 640679),
  createData("United Kingdom", "GB", 67545757, 242495),
  createData("Russia", "RU", 146793744, 17098246),
  createData("Nigeria", "NG", 200962417, 923768),
  createData("Brazil", "BR", 210147125, 8515767),
];
function Row(props) {
  const { userRole } = useAuth();

  const { row, fetchData, setSelectedRow, setOpenViewImage, setSelectFileRow } =
    props;
  const [open, setOpen] = React.useState(false);
  const [token, setToken] = useState(getCookie("token"));
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedRowDelete, setSelectedRowDelete] = useState({});
  const [isOpenView, setIsOpenView] = useState(false);
  const [isOpenPdf, setIsOpenPdf] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  const [selectedPaymentRow, setSelectedPaymentRow] = useState(null);
  const navigate = useNavigate();

  const decodedToken = token ? jwtDecode(token) : null;
  const handleOpenImage = (row) => {
    setSelectedRow(row);
    setOpenViewImage(true);
  };
  const handleSelectFile = (row) => {
    setSelectFileRow(row);
  };

  const handleArticleClick = (id) => {
    navigate(`/admin/submitted-article/${id}`);
  };

  const viewPaymentProof = (val) => {
    setIsOpenView(true);
    setSelectedPaymentRow(val);
  };

  const viewPdf = (val) => {
    if (val?.file) {
      setIsOpenPdf(true);
      setPdfData(val);
    }
  };

  // delete article
  const handleClickDelete = (row) => {
    setSelectedRowDelete(row);
    setOpenDelete(true);
  };
  const handleDelete = async () => {
    try {
      const list = await getArticleService.DeleteArticle(selectedRowDelete.id);
      fetchData();
      setOpenDelete(false);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  const handleClose = () => {
    setOpenDelete(false);
  };

  const paymentStatus = getPaymentStatus(row);

  console.log("selectedpaymentrow", selectedPaymentRow);

  useEffect(() => {
    if (row.id === selectedPaymentRow?.id) {
      setSelectedPaymentRow(row);
    }
  }, [row]);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell
          align="center"
          onClick={() => handleArticleClick(row.id)}
          sx={{
            cursor: "pointer",
            color: "primary.main",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {row.id}
        </TableCell>

        <TableCell align="center">
          {row.clientDetails?.first_name ||
            "" + " " + row.clientDetails?.last_name ||
            ""}
        </TableCell>
        <TableCell align="center">
          {moment(row.createdAt).format("DD-MM-YYYY")}
        </TableCell>

        <TableCell align="center">
          {moment(row.modifiedAt).format("DD-MM-YYYY")}
        </TableCell>

        <TableCell align="center">{row.journalName}</TableCell>
        <TableCell align="center">
          <Badge
            bg={getPublicationColor(row.publicationDetails?.name)}
            style={{
              fontSize: "16px",
              backgroundColor: getPublicationColor(
                row.publicationDetails?.name
              ),
              color: "#fff",
              padding: "8px 16px",
              borderRadius: "20px",
              fontWeight: "600",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              textTransform: "capitalize",
            }}
          >
            {row.publicationDetails?.name}
          </Badge>
        </TableCell>

        <TableCell align="center">{row.payerName}</TableCell>
        <TableCell align="center">{row.emailId}</TableCell>
        <TableCell align="center">{row.currency}</TableCell>

        <TableCell align="center">{row.totalfees}</TableCell>
        <TableCell align="center">{row.taxRate}% </TableCell>
        <TableCell align="center">{row.taxAmount}</TableCell>
        <TableCell align="center">{row.feesRecived}</TableCell>
        <TableCell align="center">{row.remaningFees}</TableCell>
        {/* <TableCell align="center">{row.publicationType}</TableCell> */}

        <TableCell align="center">
          {row.payments &&
            (Array.isArray(row.payments)
              ? row.payments.length > 0
              : row.payments.split(",").length > 0) && (
              <Button
                variant="contained"
                className="me-2"
                color="primary"
                onClick={() => viewPaymentProof(row)}
              >
                View Proof
              </Button>
            )}

          <Chip
            label={paymentStatus.label}
            color={paymentStatus.color}
            size="medium"
            sx={{
              fontWeight: 500,
              minWidth: "120px",
            }}
          />
        </TableCell>

        <TableCell align="center">
          {userRole !== "tl" && (
            <Button
              variant="contained"
              className="ms-2"
              color="secondary"
              size="small"
              onClick={() => handleClickDelete(row)}
            >
              Delete
            </Button>
          )}
        </TableCell>
      </TableRow>

      <DeleteConfirm
        openDelete={openDelete}
        handleDelete={handleDelete}
        handleClose={handleClose}
      />
      <ViewPaymentProof
        articleData={selectedPaymentRow}
        isOpenView={isOpenView}
        setIsOpenView={setIsOpenView}
        reFetchData={fetchData}
      />
      <ViewPdf
        isOpenPdf={isOpenPdf}
        setIsOpenPdf={setIsOpenPdf}
        pdfData={pdfData}
      />
    </React.Fragment>
  );
}

const List = ({ getdata, fetchData, filterVal, setFilterVal }) => {
  const { userRole } = useAuth();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [selectedRow, setSelectedRow] = useState("");
  const [openViewImage, setOpenViewImage] = useState(false);
  const [selectFileRow, setSelectFileRow] = useState();
  const fetchPreSignedUrl = async () => {
    const filterVal = {
      key: selectFileRow?.file,
    };
    try {
      const data = await getArticleService.getFilePreSIgnedUrl(filterVal);
      setSelectFileRow();

      if (data) {
        const link = document.createElement("a");
        link.href = data;
        link.click();
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  useEffect(() => {
    if (selectFileRow?.file) {
      fetchPreSignedUrl();
    }
  }, [selectFileRow?.file]);

  const handleChangePage = (event, newPage) => {
    console.log("newPage", newPage);
    setFilterVal({ ...filterVal, pageNumber: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleCloseViewImage = () => {
    setOpenViewImage(false);
  };
  const handleVerifyPayment = async () => {
    let data = {
      paymentStatus: !selectedRow.paymentStatus,
    };
    try {
      const list = await getArticleService.UpdateArticle(data, selectedRow.id);

      fetchData();
      setOpenViewImage(false);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  return (
    <Paper sx={{ width: "100%", boxShadow: "none", height: "100%" }}>
      <TableContainer sx={{ minHeight: "62vh", maxHeight: "62vh" }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => {
                if (userRole === "tl" && column.id === "Action") return null;
                return (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {getdata.map((row) => {
              return (
                <Row
                  row={row}
                  setSelectFileRow={setSelectFileRow}
                  setSelectedRow={setSelectedRow}
                  setOpenViewImage={setOpenViewImage}
                  fetchData={fetchData}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <div className="d-flex justify-content-end mt-3 mb-3 px-4">
        <Pagination
          page={filterVal.pageNumber}
          onChange={handleChangePage}
          count={filterVal.totalPages}
          variant="outlined"
          color="primary"
        />
      </div>
      <PaymentVerify
        selectedRow={selectedRow}
        openViewImage={openViewImage}
        handleVerifyPayment={handleVerifyPayment}
        handleCloseViewImage={handleCloseViewImage}
      />
    </Paper>
  );
};

export default List;
